import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Button } from 'components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from 'components/ui/card';
import { useLanguage } from 'lib/i18n';
import api from 'lib/api';
import { MailCheck } from 'lucide-react';

export default function UnsubscribePage() {
  const [searchParams] = useSearchParams();
  const { t } = useLanguage();
  const token = searchParams.get('token') || '';
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const unsubscribe = async () => {
    if (!token || busy) return;
    setBusy(true);
    setError('');
    try {
      await api.post(`/users/marketing/unsubscribe/${encodeURIComponent(token)}`);
      setDone(true);
    } catch {
      setError(t('unsubscribe.error'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-muted/40 p-4">
      <Card className="w-full max-w-lg">
        <CardHeader className="items-center text-center">
          <div className="mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary"><MailCheck size={24} /></div>
          <CardTitle>{done ? t('unsubscribe.doneTitle') : t('unsubscribe.title')}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 text-center">
          <p className="text-sm text-muted-foreground">{done ? t('unsubscribe.doneText') : t('unsubscribe.description')}</p>
          {!done && token && <Button onClick={unsubscribe} disabled={busy}>{busy ? t('unsubscribe.busy') : t('unsubscribe.confirm')}</Button>}
          {!token && <p role="alert" className="text-sm text-destructive">{t('unsubscribe.invalid')}</p>}
          {error && <p role="alert" className="text-sm text-destructive">{error}</p>}
        </CardContent>
      </Card>
    </main>
  );
}
